@if (flux()) {
  <section (insideViewport)="handleVisibilityChange($event)" class="instagram" id="instagram-component">
    <div class="carousel">
      <div
        #carouselContent
        (mouseenter)="pause()"
        (mouseleave)="start()"
        (scrollend)="onScrollEnd()"
        (touchend)="onTouchEnd()"
        (touchstart)="pause()"
        class="carousel-content">
        @for (item of flux()!.items; track item; let i = $index) {
          @if (item.images.length > 0) {
            <div #carouselItemContainer class="carousel-item-container">
              <div #carouselItem (click)="openInstagramDialog(i)" class="carousel-item">
                @if (cardSize()) {
                  <app-image
                    [image]="item.images[0]!"
                    [size]="{ dw: cardSize(), dh: cardSize(), mw: cardSize(), mh: cardSize() }" />
                }
              </div>
            </div>
          }
        }
      </div>
    </div>
  </section>
  <app-instagram-dialog [flux]="flux()!" [widthChange]="widthChange()" />
}
